import { Input, Label, Text, Textarea } from '@thefarmersfront/kitchen';

import { useGetActiveSkusSkuCodeQuery, useGetSkusSkuCodeQuery } from '~/hooks/product';

import styles from './ProductDetailsModalDefaultSection.module.scss';

const ProductDetailModalDefaultSection = ({ skuCode, isActiveSku }: { skuCode: string; isActiveSku?: boolean }) => {
  const skuDetailQuery = useGetSkusSkuCodeQuery({
    skuCode,
    enabled: !isActiveSku,
  });

  const activeSkuDetailQuery = useGetActiveSkusSkuCodeQuery({
    skuCode,
    enabled: !!isActiveSku,
  });

  const detailData = isActiveSku ? (activeSkuDetailQuery.data ?? null) : (skuDetailQuery.data ?? null);

  return (
    <div className={styles['default-info-section']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold">
        기본 정보
      </Text>
      <div className={styles['item-row']}>
        <Label className={styles['label']} title="화주사명" required />
        <div className={styles['input-wrapper']}>
          <Input disabled type="text" size="small" name="venderName" value={detailData?.consignorName ?? ''} />
        </div>
      </div>
      <div className={styles['supplier-item-row']}>
        <Label className={`${styles['label']} ${styles['supplier-label']}`} title="공급사명" required />
        <div className={styles['textarea-wrapper']}>
          <Textarea
            disabled
            name="suppliers"
            size="small"
            value={detailData?.supplierList.map(({ supplierName }) => supplierName).join(', ') ?? ''}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModalDefaultSection;
